import { Link, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { CodeIcon } from "./icons/themes/windows10";

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
  },
  subtitleWrapper: {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    cursor: "pointer",
  },
}));

export const CopyHelper: React.FC<{
  labelText: string;
  copyText: string;
  tooltipText: string;
}> = ({ labelText, copyText, tooltipText }) => {
  const classes = useStyles();

  return (
    <Tooltip className={classes.subtitleWrapper} title={tooltipText}>
      <Link
        color="inherit"
        className={classes.subtitleWrapper}
        onClick={() => navigator.clipboard.writeText(`${copyText}`)}
      >
        <>
          {`${labelText}`}
          <CodeIcon className={classes.icon} />
        </>
      </Link>
    </Tooltip>
  );
};
